import {
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { Subject, forkJoin } from "rxjs";
import { CommonService } from "./../services/common.service";
import { environment } from "../../environments/environment";
import { JoinMeeting } from "../../app/samvaad-join-meeting.component";
import { dataDictionary } from "../../app/dataDictionary";
import { ValidationsComponent } from "./validations.component";

export abstract class BaseComponent extends ValidationsComponent {
  table: Array<any> = [];
  appealStatus: Array<any> = [];
  pgSze: number = 20;
  crntPage: number = 1;
  ttlItms: any = 0;
  pageEntry: any = "";
  selectedStatusId: any = null;
  moduleId: string = "";
  isEdit: boolean = false;
  srchFltr = "";
  tenanates: Array<any> = [];
  roleId: any = sessionStorage.getItem("RoleId");
  roleName: any = localStorage.getItem("RoleName");
  TenantCode: any = sessionStorage.getItem("TenantCode");
  userId: any = sessionStorage.getItem("UserId");
  deptId: any = localStorage.getItem("DepartmentId");
  userName: any = localStorage.getItem("Username");
  emailId: any = sessionStorage.getItem("USERNAME");
  myForm: FormGroup | any;
  editData: any = {};
  tId: string = "";
  file: File | any;
  fileName: string = "";
  courses: Array<any> = [];
  courseId: any = "";
  shedules: Array<any> = [];
  schedules: Array<any> = [];
  subjects: Array<any> = [];
  subjectId: string = "";
  scheduleId: string = "";
  public dtTrigger: Subject<any> = new Subject<any>();
  dtOptions: any = {};
  formBuilder: UntypedFormBuilder = new UntypedFormBuilder();
  loadTenanat: boolean = true;
  fileUrl: string = environment.fileUrl;
  videoUrl: string = environment.videoUrl;
  MeetingCheckSumUrl = new JoinMeeting();
  is_company: boolean = sessionStorage.is_company == "false" ? false : true;
  academics: Array<any> = [];
  schools: Array<any> = [];
  semesters: Array<any> = [];
  studyyears: Array<any> = [];
  academicId: string = "";
  semesterId: string = "";
  studyYearId: string = "";
  cohorts: Array<any> = [];
  cohortId: string = "";
  schoolId: string = "";
  isRecommondations: boolean = false;
  isUploadPortfolio: boolean = false;
  disableProgramDetailsActive: boolean = false;
  showReferredBox: boolean = false;
  Referrals: boolean = false;
  applicationProgram: boolean = false;
  programDetailsActive: boolean = true;
  applicationTypes: Array<any> = [];
  personalEmail: string = "";
  superModuleList: Array<any> = [];
  wardens: Array<any> = [];
  staffs: Array<any> = [];
  allRoles = [
    { id: 1, role: "Admin" },
    { id: 2, role: "Trainer" },
    { id: 3, role: "Trainee" },
    { id: 4, role: "Super Admin" },
  ];
  Programs: Array<any> = [];
  referrals: Array<any> = [];
  floors: Array<any> = [];
  blocks: Array<any> = [];
  hostels: Array<any> = [];
  commentsData: Array<any> = [];
  panel_remarks: string = "";
  iec_remarks: string = "";
  selectedReferral: string = "";
  REFERRAL_NAME: string = "";
  progress: number = 0;
  progressOne: number = 0;
  progressTwo: number = 0;
  progressThree: number = 0;
  ISRPL: boolean = false;
  IS_RPL: boolean = false;

  isProgress: boolean = false;
  isProgressOne: boolean = false;
  isProgressTwo: boolean = false;
  isProgressThree: boolean = false;
  incidents: Array<any> = [];
  registrationNumbers: Array<any> = [];
  rooms: Array<any> = [];
  staffList: { item_id: number; item_text: string }[] = [];
  buttonDisableOrEnable: boolean = false;
  regNumbers: Array<any> = [];
  studentRegNumbers: Array<any> = [];
  todayDate: string = "";
  selectedItem: any;
  get RoleName(): string {
    if (
      +this.roleId == 1 &&
      ["shiksion.com", "localhost"].includes(location.hostname)
    )
      return this.allRoles[1].role;
    else {
      const role: string =
        this.allRoles.find((e) => e.id == +this.roleId)?.role ?? "";
      return role;
    }
  }
  get isPermission(): boolean {
    if (
      [1, 4].includes(+this.roleId) ||
      (+this.roleId == 2 && this.is_company == false)
    )
      return true;
    else return false;
  }

  get ScreenPermission(): boolean {
    /*
        2--->Trainer
        3--->Trainee
        */
    return this.is_company == false || [2, 3].includes(+this.roleId);
  }

  //   fb:FormBuilder=new FormBuilder();
  get isSuperAdmin(): boolean {
    if (sessionStorage.getItem("RoleId") == "4") {
      return true;
    } else return false;
  }
  constructor(
    protected CommonService: CommonService,
    protected toastr: ToastrService,
  ) {
    super();
    if (this.loadTenanat) this.getTennates();
    const today = new Date();
    this.todayDate = today.toISOString().split("T")[0];
    // this.getProgramTypes();
  }
  isAlphabetsOnly(value: string): boolean {
    throw new Error("Method not implemented.");
  }
  activeSpinner() {
    this.CommonService.activateSpinner();
  }

  deactivateSpinner() {
    this.CommonService.deactivateSpinner();
  }
  getProgramTypes() {
    this.applicationTypes = [];
    this.CommonService.postCall("CourseSchedule/GetCourseType", {
      TENANT_CODE: this.TenantCode,
    }).subscribe((res: any) => {
      this.applicationTypes = res.filter((e: any) => e.COURSE_TYPE_ID != 3);
    });
  }
  getGridData(route: string, payload: any, callBack?: Function) {
    this.activeSpinner();
    this.CommonService.postCall(route, payload).subscribe(
      (res: any) => {
        this.deactivateSpinner();
        this.table = [];
        setTimeout(() => {
          this.table = res;
          if (callBack) {
            callBack();
          }
        });
      },
      (err) => {
        this.deactivateSpinner();
      },
    );
  }
  public getTennates(callBack?: Function) {
    if (!this.isSuperAdmin) return;
    this.activeSpinner();
    this.CommonService.postCall("GetTenantByRoleId", {
      RoleId: this.roleId,
    }).subscribe(
      (res) => {
        this.tenanates = res;
        this.deactivateSpinner();
        if (callBack) {
          callBack();
        }
      },
      (err) => {
        this.deactivateSpinner();
      },
    );
  }
  renderDataTable() {
    let t = $("#DataTables_Table_0").DataTable();
    t.destroy();
    this.dtTrigger.next();
  }

  loadDataTable(tableName: string = "DataTables_Table_0") {
    let t = $("#" + tableName).DataTable();
    t.destroy();
    // this.dtTrigger.next();
  }
  changeTname() {}

  ///get admin cources
  getCourses(callback?: Function) {
    this.activeSpinner();
    let id = this.tId == "" ? null : this.tId;
    this.CommonService.getAdminCourses(id).subscribe(
      (res: any) => {
        this.courses = res;
        this.deactivateSpinner();
        if (callback) {
          callback();
        }
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  courseChange(callBack?: Function) {
    let data = {
      CourseId: this.courseId,
    };
    this.activeSpinner();
    this.CommonService.getAdminCourseSchedule(data).subscribe(
      (res: any) => {
        this.deactivateSpinner();
        this.shedules = res;
        this.schedules = res;
        if (callBack) {
          callBack();
        }
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }

  //////////////////default action in page////////////////////
  post(url: any, payload: any, callback?: Function) {
    this.activeSpinner();
    this.CommonService.postCall(url, payload).subscribe(
      (res) => {
        this.deactivateSpinner();
        if (callback) {
          callback(res);
        }
      },
      (err) => {
        this.deactivateSpinner();
      },
    );
  }

  add() {}
  close() {}
  onSubmit(form?: UntypedFormGroup) {}
  //////////////////default action in page////////////////////

  loadReportDtOptions() {
    this.dtOptions = {
      dom: "Bfrtip",
      buttons: ["excel"],
      order: [],
    };
  }
  back() {
    window.history.back();
  }
  studentCourses() {
    this.activeSpinner();
    this.CommonService.getCourses().subscribe(
      (res: any) => {
        this.deactivateSpinner();
        this.courses = res;
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }

  fileSizeCalculation(fileSize: number, targetSize: number): boolean {
    const currentfileSize = Math.round(fileSize / (1024 * targetSize));
    return currentfileSize >= 1024 * targetSize;
  }

  getFormValidationErrors(formObj: any) {
    Object.keys(formObj.controls).forEach((key) => {
      const controlErrors: ValidationErrors = formObj.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach((keyError) => {
          console.log(
            "Key control: " + key + ", keyError: " + keyError + ", err value: ",
            controlErrors[keyError],
          );
        });
      }
    });
  }

  loadImages(courseName: string) {
    const imageList = [
      { name: "Languages", path: "../../../../assets/new-images/language.jpg" },
      { name: "Music", path: "../../../../assets/new-images/music.jpg" },
      { name: "Cooking", path: "../../../../assets/new-images/cooking.jpg" },
      {
        name: "Programming Languages",
        path: "../../../../assets/new-images/ProgrammingLanguages.jpeg",
      },
      {
        name: "Post-Graduate Programme in Business Analytics",
        path: "../../../../assets/new-images/pg.jpg",
      },
      { name: "Angular", path: "../../../../assets/new-images/angular.jpg" },
      {
        name: "Machine Learning & AI",
        path: "../../../../assets/new-images/artificial_intelligence.jpg",
      },
      {
        name: "Web Development",
        path: "../../../../assets/new-images/web_development.jpg",
      },
    ];

    let imageObj = imageList.find((e) => e.name == courseName);
    return imageObj
      ? imageObj.path
      : "../../../../assets/img/course-card/image.png";
  }

  getImagePath(path: string, courseName: string): string {
    const index = path?.indexOf("/OneApp") ?? -1;

    const newPath: string =
      index > -1 ? `${this.fileUrl}${path}` : this.loadImages(courseName);
    return newPath;
  }
  getImagePathCourse(path: string, courseName: string): string {
    const newpath = `${this.videoUrl}${path}`;
    return newpath;
  }
  getMeetingDetails(url: any) {
    const meetingURLParams = url.split("/");
    const meetingId = meetingURLParams[meetingURLParams.length - 1];
    this.activeSpinner();
    this.CommonService.getCall(
      "conclave/nojwt/meeting/getMeetingDetails/",
      meetingId,
      true,
    ).subscribe(
      (res: any) => {
        const data = res.data.meetingdetails;
        this.getCheckSumUrl(data);
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
        // console.log(e, 'error getMeetingDetails');
        this.toastr.error(e.error?.message);
      },
    );
  }

  getCheckSumUrl(data: any) {
    this.activeSpinner();
    let payload = {
      ...this.MeetingCheckSumUrl,
      // fullName: data.fullName,
      fullName: sessionStorage.getItem("Username"),
      meetingID: data.meetingID,
      role: data.role,
      endTime: data.EndTime,
      meetingTitle: data.name,
      hostName: data.hostName,
      startTime: data.StartTime,
      domain_URL: data.domainUrl,
      username: sessionStorage.getItem("Username"),
      mail: sessionStorage.getItem("USERNAME"),
    };
    this.CommonService.postCall(
      "conclave/nojwt/session/getHostCreateAndJoinCheckSumUrl",
      payload,
      true,
    ).subscribe(
      (res: any) => {
        this.deactivateSpinner();
        this.joinSamvaadMeeting(res);
      },
      (e) => {
        this.deactivateSpinner();
        // console.log(e, '--------getHostCreateAndJoinCheckSumUrl');
        this.toastr.error(e.error?.message);
      },
    );
  }

  joinSamvaadMeeting(res: any) {
    window.open(res.data.joinUrl);
  }

  setServerPath(path: string) {
    return this.fileUrl + path;
  }

  convertDataUrlToBlob(dataUrl: any) {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  }

  generateFile(
    ImageURL: string = "",
    filename: string = "Sample12345.png",
    extension: string = "png",
  ) {
    const file = new File([this.convertDataUrlToBlob(ImageURL)], filename, {
      type: `image/${extension}`,
    });
    return file;
  }
  // ----------------------------Reusable Validations---------------------------------------------
  // --------------only allow Numbers Validation in input type text-----------------------
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  getChartOfAccountInfo(): any {
    let { chartOfAccountId = 0 } = sessionStorage;
    if (+chartOfAccountId <= 0) {
      this.activeSpinner();
      this.CommonService.getCall(
        `ChartOfAccount/GetList/${this.TenantCode}/-1`,
      ).subscribe(
        (res: any) => {
          this.deactivateSpinner();
          if (res.status == true && res.data.length > 0) {
            sessionStorage.chartOfAccountId = res.data[0].cha_chartofaccount_id;
            return +sessionStorage.chartOfAccountId;
          }
        },
        (e) => {
          this.deactivateSpinner();
          return 0;
        },
      );
    } else return chartOfAccountId;
  }

  voucherOnKeyPress(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if ((charCode >= 48 && charCode <= 57) || charCode === 46) {
      if (charCode === 46 && event.target.value.includes(".")) {
        event.preventDefault();
      } else {
        const dotIndex = event.target.value.indexOf(".");
        if (
          dotIndex !== -1 &&
          event.target.value.substring(dotIndex + 1).length >= 4
        ) {
          event.preventDefault();
        }
      }
    } else {
      event.preventDefault();
    }
  }
  programDropdown() {
    this.activeSpinner();
    let payLoad = {
      TENANT_CODE: this.tId || localStorage.getItem("TenantCode"),
      ROLE_NAME: localStorage.getItem("RoleName"),
      USER_ID: localStorage.getItem("UserId"),
    };
    this.CommonService.postCall("LoadChapterCourse", payLoad).subscribe(
      (res: any) => {
        this.courses = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  getAcademic() {
    this.academics = [];
    this.activeSpinner();
    this.CommonService.getCall(
      "Academic/GetAcademicDropDownList/" + localStorage.getItem("TenantCode"),
    ).subscribe(
      (res: any) => {
        this.academics = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  getSchools() {
    this.activeSpinner();
    let payLoad: any = {
      TENANT_CODE: localStorage.getItem("TenantCode"),
    };
    this.schools = [];
    this.CommonService.postCall(
      "CourseCategory/GetCourseCategory",
      payLoad,
    ).subscribe(
      (res: any) => {
        this.schools = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  getSubjects() {
    this.activeSpinner();
    let payLoad: any = {
      tnt_code: localStorage.getItem("TenantCode"),
    };
    this.subjects = [];
    this.CommonService.postCall("Subject/LoadSubjectsList", payLoad).subscribe(
      (res: any) => {
        this.subjects = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  getSemesterOrCourseYear() {
    this.activeSpinner();
    let courseYear = this.CommonService.postCall("GetDictionaryByKey", {
      DictionaryCode: dataDictionary.CourseYear,
    });
    let semister = this.CommonService.postCall("GetDictionaryByKey", {
      DictionaryCode: dataDictionary.Semester,
    });
    // let section = this.CommonService.postCall('GetDictionaryByKey', { DictionaryCode: dataDictionary.Sections });
    let dropdowns = ["studyyears", "semesters"];
    forkJoin([courseYear, semister]).subscribe(
      (res) => {
        dropdowns.map((key, index) => {
          this[key] = res[index];
        });
        this.deactivateSpinner();
      },
      (err) => {
        this.deactivateSpinner();
      },
    );
  }
  changeProgram(programId: any) {
    this.activeSpinner();
    this.cohorts = [];
    this.CommonService.postCall(
      "CohortCurriculumMapping/LoadCohortMaplistByCourse",
      {
        COURSE_ID: programId,
        TNT_CODE: this.TenantCode,
      },
    ).subscribe(
      (res: any) => {
        this.cohorts = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  getCohortsDrpDown() {
    this.cohorts = [];
    this.CommonService.postCall("CohortManagement/GetCohortDropdownlist", {
      TNT_CODE: this.TenantCode,
    }).subscribe((res: any) => {
      this.cohorts = res;
    });
  }
  getStudyYearDropdown() {
    let courseYear = this.CommonService.postCall("GetDictionaryByKey", {
      DictionaryCode: dataDictionary.CourseYear,
    });
    let dropdowns = ["studyyears"];
    forkJoin([courseYear]).subscribe((res) => {
      dropdowns.map((key, index) => {
        this[key] = res[index];
      });
    });
  }
  getSemesterDropdown() {
    let semister = this.CommonService.postCall("GetDictionaryByKey", {
      DictionaryCode: dataDictionary.Semester,
    });
    // let section = this.CommonService.postCall('GetDictionaryByKey', { DictionaryCode: dataDictionary.Sections });
    let dropdowns = ["semesters"];
    forkJoin([semister]).subscribe((res) => {
      dropdowns.map((key, index) => {
        this[key] = res[index];
      });
    });
  }
  loadPrograms() {
    this.activeSpinner();
    this.CommonService.getAdminCourses().subscribe(
      (res: any) => {
        this.Programs = res;
        // this.onProgramChange(this.editData.COURSE_ID);
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  getDeanHodPrograms() {
    this.activeSpinner();
    this.CommonService.postCall("Courses/GetCoursesByDeanHod", {
      TNT_CODE: this.TenantCode,
      COURSE_CATEGORY_ID: localStorage.getItem("SchoolId"),
      DEPARTMENT_ID: localStorage.getItem("DepartmentId"),
    }).subscribe(
      (res: any) => {
        this.Programs = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  getReferrals() {
    this.referrals = [];
    this.CommonService.getCall("Registration/LoadReferncePlatforms").subscribe(
      (res: any) => {
        this.referrals = res;
      },
    );
  }
  onlyAlphanumerics(event: KeyboardEvent) {
    const regex = new RegExp("^[a-zA-Z0-9]+$");
    const key = String.fromCharCode(event.keyCode || event.which);

    // Allow backspace, tab, arrow keys, delete, etc.
    if (
      event.key === "Backspace" ||
      event.key === "Tab" ||
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight"
    ) {
      return;
    }

    if (!regex.test(key)) {
      event.preventDefault();
    }
  }

  showportfolio(event: any) {
    if (event == true || event == "true") {
      this.isUploadPortfolio = true;
      this.IS_RPL = true;
    } else {
      this.isUploadPortfolio = false;
      this.IS_RPL = false;
    }
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }
  getIncidentDropdown() {
    this.incidents = [];
    this.CommonService.postCall("IncidentType/GetActiveList", {
      TNT_CODE: this.TenantCode,
    }).subscribe((res: any) => {
      this.incidents = res;
    });
  }

  getRegistrationNumberDropdown() {
    this.registrationNumbers = [];
    this.CommonService.postCall("Registration/GetUserRegistrationNumbersList", {
      TENANTCODE: this.TenantCode,
    }).subscribe((res: any) => {
      this.registrationNumbers = res;
    });
  }

  getCurrentDate(ctrl: string = "", dte: any = ""): string {
    // Current Date is Start Date
    const today = ctrl == "" ? new Date() : new Date(dte);
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  getCurrentDateTime(ctrl: string = "", dte: any = ""): string {
    // Current Date and Time
    const today =
      ctrl == "" ? new Date() : dte != "" ? new Date(dte) : new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const hours = String(today.getHours()).padStart(2, "0");
    const minutes = String(today.getMinutes()).padStart(2, "0");
    const seconds = String(today.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  keyPressValdsn(
    event: KeyboardEvent,
    ctrl: string = "",
    noSpace: boolean = true,
  ): boolean {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const key = event.key;

    // Allow control keys
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "Enter" ||
      key === "Delete" ||
      key === "ArrowLeft" ||
      key === "ArrowRight"
    ) {
      return true;
    }

    // Prevent space as first character
    if (key === " " && value.length === 0) {
      event.preventDefault();
      return false;
    }

    if ((key === "/" || key === ".") && value.length === 0) {
      event.preventDefault();
      return false;
    }

    if (key === " " && !noSpace && ctrl !== "A_S") {
      event.preventDefault();
      return false;
    }

    // Allow '+' only for NP
    if (key === "+") {
      if (ctrl === "NP" && value.length === 0 && !value.includes("+")) {
        return true;
      }
      event.preventDefault();
      return false;
    }

    // Allow space only after first char for A_S
    if (key === " " && ctrl === "A_S" && value.length > 0) {
      return true;
    }

    let isAllowed = false;

    switch (ctrl) {
      case "N":
        isAllowed = /^[0-9]$/.test(key);
        break;

      case "NP":
        isAllowed = /^[0-9]$/.test(key);
        break;

      case "A":
        isAllowed = /^[a-zA-Z]$/.test(key);
        break;

      case "A_S": // ✅ NEW
        isAllowed = /^[a-zA-Z ]$/.test(key);
        break;

      case "AN":
        isAllowed = /^[a-zA-Z0-9]$/.test(key);
        break;

      case "AN/":
        isAllowed = /^[a-zA-Z0-9\/]$/.test(key);
        break;

      case "AN-":
        isAllowed = /^[a-zA-Z0-9\-]$/.test(key);
        break;

      case "AS":
        isAllowed = /^[a-zA-Z0-9 !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]$/.test(
          key,
        );
        break;

      case "S":
        isAllowed = /^[^a-zA-Z0-9 ]$/.test(key);
        break;

      default:
        isAllowed = true;
    }

    if (!isAllowed) {
      event.preventDefault();
      return false;
    }

    return true;
  }

  getSuperModules() {
    this.superModuleList = [];
    this.CommonService.postCall("TaskManager/LoadModules", {}).subscribe(
      (res: any) => {
        this.superModuleList = res;
      },
    );
  }
  getWardenDropdown() {
    this.activeSpinner();
    this.wardens = [];
    this.CommonService.postCall("HostelMaster/GetWarden", {}).subscribe(
      (res: any) => {
        this.wardens = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  getStaffDropdown() {
    this.activeSpinner();
    this.staffs = [];
    this.CommonService.postCall("HostelMaster/GetStaff", {}).subscribe(
      (res: any) => {
        this.staffs = res;
        res.map((item) => {
          let obj = {
            item_id: item.userid,
            item_text: item.name,
          };
          this.staffList.push(obj);
        });
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  hostelDropdown() {
    this.activeSpinner();
    this.hostels = [];

    this.CommonService.postCall("HostelBlock/ActiveHostelList", {
      tnt_code: this.TenantCode,
    }).subscribe(
      (res: any) => {
        this.hostels = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  blockDropdown(hostelId: any) {
    if (!this.isEdit) {
      this.myForm.patchValue({
        block_id: "",
        floor_id: "",
        room_id: "",
      });
    }

    this.blocks = [];
    this.floors = [];

    this.activeSpinner();
    this.CommonService.postCall("HostelFloor/ActiveBlockList", {
      tnt_code: this.TenantCode,
      hostel_id: hostelId,
    }).subscribe(
      (res: any) => {
        this.blocks = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  floorDropdown(blockId: any) {
    this.floors = [];
    if (!this.isEdit)
      this.myForm.patchValue({
        floor_id: "",
        room_id: "",
      });

    this.activeSpinner();
    this.CommonService.postCall("HostelRoom/ActiveRoomList", {
      tnt_code: this.TenantCode,
      block_id: blockId,
    }).subscribe(
      (res: any) => {
        this.floors = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }
  roomsDropdown() {
    this.rooms = [];
    if (!this.isEdit && this.myForm)
      this.myForm.patchValue({
        room_id: "",
      });
    this.activeSpinner();
    this.CommonService.postCall("HostelRoomBooking/AvailableHostelRooms", {
      tnt_code: this.TenantCode,
    }).subscribe(
      (res: any) => {
        this.rooms = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }

  GetPageSizeTxt(crntPage: any, totalItems: any, pageSize: any = 20) {
    return this.ttlItms == 0
      ? ""
      : `Showing ${crntPage * pageSize - (pageSize - 1)}-${
          crntPage * pageSize < totalItems ? crntPage * pageSize : totalItems
        } of ${totalItems} entries`;
  }

  validateDecKey(event: any) {
    const inp = event.key;
    const value = event.target.value;

    // Allow only digits and dot
    if (!/[\d.]/.test(inp)) {
      event.preventDefault();
      return;
    }

    // Prevent more than one dot
    if (inp === "." && value.includes(".")) {
      event.preventDefault();
      return;
    }

    // Limit to 2 digits after dot
    if (value.includes(".")) {
      const decimal = value.split(".")[1];
      if (decimal && decimal.length >= 2) {
        event.preventDefault();
      }
    }
  }
  getRegNumbersDropdown() {
    this.CommonService.activateSpinner();
    this.regNumbers = [];
    this.CommonService.postCall(
      "Registration/GetUsersDropDownStudentInformation",
      {
        TNT_CODE: localStorage.getItem("TenantCode"),
      },
    ).subscribe(
      (res: any) => {
        this.regNumbers = res;
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
      },
    );
  }
  getRegistrationNumbers() {
    this.activeSpinner();
    this.studentRegNumbers = [];
    this.CommonService.getCall(
      "Registration/GetRegistrationNumbersList",
    ).subscribe(
      (res: any) => {
        this.studentRegNumbers = res;
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
      },
    );
  }
  preventTyping(event: KeyboardEvent) {
    event.preventDefault();
  }
  getAppealStatus(id: any) {
    this.appealStatus = [];
    this.CommonService.postCall(
      "ElectionAppealCategory/GetElectionAppealStatus",
      {
        type_id: id,
      },
    ).subscribe((res: any) => {
      this.appealStatus = res;
    });
  }

  getComments(item: any, type: any) {
    this.activeSpinner();

    // Reset values
    this.panel_remarks = "";
    this.iec_remarks = "";

    this.CommonService.postCall(
      "ElectionAppealCategory/GetElectionAppealComments",
      {
        election_appeal_id: item.election_appeal_id,
        type_id: type,
      },
    ).subscribe(
      (res: any) => {
        this.commentsData = res;

        if (res && res.length) {
          res.forEach((element: any) => {
            // IEC Remarks
            if (Number(element.type_id) === 2) {
              this.iec_remarks = element.review_comments;
            }

            // Panel Remarks
            if (Number(element.type_id) === 1) {
              this.panel_remarks = element.review_comments;
            }
          });
        }

        this.deactivateSpinner();
      },
      (error: any) => {
        this.deactivateSpinner();
      },
    );
  }
}
